import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { openModal, openWriteToUs } from "@common/actions/index";
import { DEFAULT_LOGGED_ROUTE, FREQUENTLY_ASKED_QUESTIONS, LOGO_SITE_MOBILE, LOGO_SITE_WEB, TOOLTIP_SHOW_DELAY } from "@config/constants";
var OrderHeader = function(props) {
    var template = null;
    var i18n = props.i18n, screenType = props.screenType, _$openWriteToUs = props.openWriteToUs;
    var logo = screenType.smallMobile ? LOGO_SITE_MOBILE : LOGO_SITE_WEB;
    if (typeof i18n === "undefined") {
        template = /*#__PURE__*/ _jsx("div", {
            children: "No translations!"
        });
    } else {
        template = /*#__PURE__*/ _jsx("div", {
            className: "header-wrapper",
            children: /*#__PURE__*/ _jsxs("header", {
                className: "subscriptions",
                children: [
                    /*#__PURE__*/ _jsx(ReactTooltip, {
                        id: "order-tooltip",
                        className: "tooltip",
                        delayShow: TOOLTIP_SHOW_DELAY,
                        place: "bottom",
                        effect: "solid"
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        to: DEFAULT_LOGGED_ROUTE,
                        className: "logo logo-header",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: logo,
                            alt: "logo"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "sub-navigation",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "icon icon-help pointer",
                                "data-tip": i18n.common.help,
                                "data-for": "order-tooltip",
                                onClick: function() {
                                    return props.openModal(FREQUENTLY_ASKED_QUESTIONS);
                                },
                                onKeyDown: function() {
                                    return props.openModal(FREQUENTLY_ASKED_QUESTIONS);
                                }
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "write-us",
                                onClick: _$openWriteToUs,
                                onKeyDown: _$openWriteToUs,
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon icon-contact-us pointer"
                                    }),
                                    !screenType.mobile ? /*#__PURE__*/ _jsxs("span", {
                                        className: "text",
                                        children: [
                                            i18n.writeToUs,
                                            "."
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
    return template;
};
export default connect(null, {
    openModal: openModal,
    openWriteToUs: openWriteToUs
})(OrderHeader);
